module.exports = __webpack_public_path__ + "static/media/size-chart-add.45057fff.svg";